// extracted by mini-css-extract-plugin
export default {"wrapper":"CartButton_wrapper__ga60Y","container":"CartButton_container__MSl2b","badge":"CartButton_badge__sIEmM","badgeText":"CartButton_badgeText__Y8WiW"};